const experiencesData = [
    {
        year: '2025-Present',
        title: 'Senior Chief Engineer',
        company: 'Samsung',
        description: 'Working in cutting-edge next generation 6G.',
        logo: '/images/samsung.webp',
    },
    {
        year: '2024-2025',
        title: 'AI Engineer',
        company: 'IBM',
        description: 'Pioneering AI solutions leveraging NLP and optimizing algorithms for IBM mainframes.',
        logo: '/images/ibm.webp',
    },
    {
        year: '2019-2024',
        title: 'Lead Software Engineer',
        company: 'Beckman Coulter',
        description: 'Developed C++ and CUDA applications for surgical microscopes and medical imaging.',
        logo: '/images/leica.webp',
    },
    {
        year: '2017-2019',
        title: 'Senior Software Engineer',
        company: 'LG Soft India',
        description: 'Enhanced mobile camera technology with semantic segmentation algorithms.',
        logo: '/images/lgsoft.png',
    },
    {
        year: '2016-2017',
        title: 'Member of technical staff',
        company: 'Graphene Semiconductor Services',
        description: 'Worked in SSD performance benchmarking tool through windows device drivers.',
        logo: '/images/gss.webp',
    },
    {
        year: '2012-2013',
        title: 'Associate Software Engineer',
        company: 'Captronic Systems',
        description: 'Worked on test equipment manufacturing.',
        logo: '/images/captronic_systems.webp',
    },
];

const educationData = [
    {
        year: '2013-2015',
        degree: 'M.Tech, Electronics and Communications',
        institution: 'National Institute of Technology, Kurukshetra',
        logo: '/images/nit.webp'
    },
    {
        year: '2009-2013',
        degree: 'B.E, Electronics and Communications',
        institution: 'Visvesvaraya Technological University',
        logo: '/images/vtu.webp'
    }
];

const journeyData = {
    experiencesData,
    educationData
};

export default journeyData;